import merge from 'lodash.merge';

const borderWidths$1 = {
  none: 0,
  sm: "1px",
  md: "2px",
  lg: "4px"
};

const colors$2 = {
  black: "#090909",
  "blue-10": "#F1F3FD",
  "blue-20": "#DADDF5",
  "blue-50": "#7185EF",
  "blue-60": "#4961F6",
  "blue-70": "#3F53D9",
  "blue-80": "#122277",
  "gray-20": "#F2F2F3",
  "gray-30": "#E7E7E7",
  "green-70": "#1E8908",
  "indigo-20": "#AFAEB8",
  "indigo-30": "#9897A4",
  "indigo-50": "#686685",
  "indigo-70": "#36345D",
  "indigo-90": "#050038",
  "pink-20": "#FFE5E5",
  "pink-50": "#FFBFBF",
  "red-10": "#FBF4F5",
  "red-20": "#F4D8DB",
  "red-30": "#F3B7BB",
  "red-50": "#FF6575",
  "red-60": "#CC4856",
  transparent: "#FFFFFF00",
  white: "#FFFFFF",
  "yellow-20": "#FDF1C6",
  "yellow-60": "#FFD02F"
};

const fontSizes$1 = {
  150: "0.75rem",
  175: "0.875rem",
  200: "1rem",
  225: "1.125rem",
  250: "1.25rem",
  300: "1.5rem",
  400: "2rem",
  500: "2.5rem",
  600: "3rem",
  800: "4rem",
  900: "4.5rem"
};

const radii$1 = {
  none: 0,
  half: "999em",
  25: "2px",
  50: "4px",
  75: "6px",
  100: "8px",
  200: "16px"
};

const shadows$1 = {
  50: "0 4px 16px #05003812",
  100: "0 8px 32px #05003808"
};

const sizesScales = [...Array(200)].reduce(
  (acc, _, i) => {
    const position = i + 1;
    return {
      ...acc,
      [position]: `${position * 4}px`
    };
  },
  {}
);
const sizes$1 = {
  "icon-200": "16px",
  "icon-300": "24px",
  "icon-400": "32px",
  ...sizesScales
};

const space$1 = {
  none: 0,
  50: "4px",
  100: "8px",
  150: "12px",
  200: "16px",
  300: "24px",
  400: "32px",
  500: "64px",
  600: "48px",
  800: "64px",
  1200: "96px",
  1600: "128px"
};

const _spaceGap = {
  none: "$space$none",
  50: "$space$50",
  100: "$space$100",
  200: "$space$200",
  300: "$space$300"
};
const spaceGap$1 = _spaceGap;

const _spaceInset = {
  none: "$space$none",
  50: "$space$50",
  100: "$space$100",
  150: "$space$150",
  200: "$space$200",
  300: "$space$300",
  400: "$space$400",
  600: "$space$600",
  800: "$space$800",
  1200: "$space$1200",
  1600: "$space$1600"
};
const spaceInset$1 = _spaceInset;

const _spaceOffset = {
  none: "$space$none",
  50: "$space$50",
  100: "$space$100",
  150: "$space$150",
  200: "$space$200",
  300: "$space$300",
  400: "$space$400",
  600: "$space$600",
  800: "$space$800",
  1200: "$space$1200",
  1600: "$space$1600",
  "stacking-none": 0,
  "stacking-100": "0.5rem",
  "stacking-200": "1rem",
  "stacking-300": "1.5rem",
  "stacking-400": "2rem",
  "stacking-500": "2.5rem",
  "stacking-800": "4rem"
};
const spaceOffset$1 = _spaceOffset;

const zIndices$1 = {
  dropdownMenu: 100,
  popover: 200,
  tooltip: 300
};

var GlobalTokens = /*#__PURE__*/Object.freeze({
  __proto__: null,
  borderWidths: borderWidths$1,
  colors: colors$2,
  fontSizes: fontSizes$1,
  radii: radii$1,
  shadows: shadows$1,
  sizes: sizes$1,
  space: space$1,
  spaceGap: spaceGap$1,
  spaceInset: spaceInset$1,
  spaceOffset: spaceOffset$1,
  zIndices: zIndices$1
});

const _colors = {
  "background-cta-active": "$blue-80",
  "background-cta-disabled": "$gray-20",
  "background-cta-hover": "$blue-70",
  "background-cta-idle": "$blue-60",
  "background-danger-active": "$red-20",
  "background-danger-hover": "$red-10",
  "background-danger-idle": "$red-60",
  "background-default-active": "$blue-20",
  "background-default-disabled": "$gray-20",
  "background-default-hover": "$blue-10",
  "background-default-idle": "$white",
  "background-default-selected": "$blue-10",
  "background-default-selected-active": "$blue-20",
  "background-info-idle": "$indigo-90",
  "background-primary": "$white",
  "background-secondary": "$indigo-90",
  "background-success-idle": "$green-70",
  "background-warning-idle": "$yellow-60",
  "border-cta-idle": "$blue-60",
  "border-default-active": "$blue-80",
  "border-default-error": "$red-60",
  "border-default-hover": "$blue-70",
  "border-default-idle": "$indigo-30",
  "border-default-selected": "$blue-60",
  "canvas-primary": "$gray-20",
  "divider-default": "$gray-30",
  "focus-ring-default": "$blue-50",
  "font-cta-idle": "$white",
  "font-default-active": "$blue-80",
  "font-default-disabled": "$indigo-30",
  "font-default-error": "$red-60",
  "font-default-hover": "$blue-70",
  "font-default-idle": "$blue-60",
  "font-default-selected": "$blue-60",
  "font-default-visited": "$blue-60",
  "font-primary": "$indigo-90",
  "font-secondary": "$indigo-50",
  "font-tertiary": "$white",
  "icon-cta-idle": "$white",
  "icon-default": "$indigo-90",
  "icon-default-active": "$blue-80",
  "icon-default-disabled": "$indigo-30",
  "icon-default-error": "$red-60",
  "icon-default-hover": "$blue-70",
  "icon-default-idle": "$blue-60",
  "icon-default-selected": "$blue-60"
};
const colors$1 = _colors;

var AliasTokens = /*#__PURE__*/Object.freeze({
  __proto__: null,
  colors: colors$1
});

const tokens = merge({}, GlobalTokens, AliasTokens);
const {
  borderWidths,
  colors,
  fontSizes,
  radii,
  shadows,
  sizes,
  space,
  spaceGap,
  spaceInset,
  spaceOffset,
  zIndices
} = tokens;

var tokens$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  borderWidths: borderWidths,
  colors: colors,
  fontSizes: fontSizes,
  radii: radii,
  shadows: shadows,
  sizes: sizes,
  space: space,
  spaceGap: spaceGap,
  spaceInset: spaceInset,
  spaceOffset: spaceOffset,
  zIndices: zIndices
});

export { AliasTokens, GlobalTokens, tokens$1 as Tokens, borderWidths, colors, fontSizes, radii, shadows, sizes, space, spaceGap, spaceInset, spaceOffset, zIndices };
//# sourceMappingURL=module.js.map
